<template>
  <div class="container-table">

    <div class="row divAddPlan">
      <div v-if="optionSelected===undefined || optionSelected.name==respuesta_negativa" class="divInfo col-8">
        <span v-if="!isManual">*Campos obligatorios: introducir al menos una acción nueva o una acción asociada para poder aguardar cambios.</span>
      </div>
      <div v-if="optionSelected !== undefined && optionSelected.name==respuesta_afirmativa" class="divInfo col-8">
      </div>

      <div class="col-4">
        <q-btn
          unelevated
          icon="add"
          class="bSecondary rigth"
          label="AÑADIR NUEVA ACCIÓN"
          @click="triggerAdd()"
          :style="isOnlyAccess? 'display:none': ''"
        />
      </div>
    </div>

    <PopUpAccionesNuevas v-model="showPopUpAddNewAccion" :currentAccion="currentAccion" />

    <q-card-section>
      <q-table
        data-cy="accion-instrumeto-table"
        title="Acciones Nuevas"
        :data="acciones"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
        :loading="isLoading"
        :visible-columns="visibleColumns"
      >
        <template
v-slot:body-cell-estado="props"
          ><q-td data-cy="estado" :props="props" key="estado">{{
            props.selected ? 'Visible' : ''
          }}</q-td></template
        >
        <template v-slot:body-cell-nombre="props">
          <q-td key="nombre" :props="props">
            {{ props.row.nombre }}
          </q-td>
        </template>
        <template v-slot:body-cell-fase="props">
          <q-td key="fase" :props="props">
            <QChipFases :value="props.row.fase.label"/>
          </q-td>
        </template>

        <template v-slot:body-cell-editar="props">
            <q-td key="editar" :props="props">
                <q-icon
                  name="o_create"
                  style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
                  @click="triggerEdit(props.row)"
                />
              </q-td>
          </template>

        <template v-slot:body-cell-eliminar="props">
          <q-td key="eliminar" :props="props">
            <q-icon
              name="o_delete"
              style="color: rgba(0, 0, 0, 0.54); font-size: 24px; cursor: pointer;"
              @click="triggerDelete(props.row)"
            />
          </q-td>
        </template>
      </q-table>
    </q-card-section>
    <DialogDelete
      v-if="rowSelectedtoDelete"
      v-model="showDialogDelete"
      dataCy="delete-accion"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar la acción? ${rowSelectedtoDelete.name}`
      "
      @save="deleteAccion()"
    />
    <PopUpAvisoNoBorraAccion v-model="showPopUpNoBorraAccion" />
  </div>
</template>
<script>
import { QTable, QTd, QCardSection } from 'quasar';
import Loading from '@/components/shared/mixins/Loading.js';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import PopUpAccionesNuevas from '@/components/PlanAccion/components/PopUpAccionesNuevas.vue';
import PopUpAvisoNoBorraAccion from '@/components/PlanAccion/components/PopUpAvisoNoBorraAccion.vue';
import Vue from 'vue';
import QChipFases from '@/components/PlanAccion/components/QChipFases.vue';
import Const from '@/components/shared/helpers/Const.js';
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';

export default {
  components: {
    QTable,
    QTd,
    QCardSection,
    QChipFases,
    DialogDelete,
    PopUpAccionesNuevas,
    PopUpAvisoNoBorraAccion
  },
  props: {
    isLoading: Boolean,
    acciones: Array,
    optionSelected: Object,
    isManual: Boolean
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  mixins: [Loading],
  data () {
    return {
      rowSelectedtoDelete: null,
      pagination: {
        rowsPerPage: 20
      },
      showDialogDelete: false,
      showPopUpAddNewAccion: false,
      showPopUpNoBorraAccion: false,
      respuesta_afirmativa: Const.RESPUESTA_NEGATIVA,
      respuesta_negativa: Const.RESPUESTA_AFIRMATIVA,
      visibleColumns: ['name', 'fase', 'plazo', 'agenteResponsable', 'editar', 'eliminar'],
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'fase',
          label: 'Fase',
          align: 'left',
          field: 'label',
          sortable: true
        },
        {
          name: 'plazo',
          label: 'Plazo',
          align: 'left',
          field: 'plazo',
          sortable: true
        },
        {
          name: 'agenteResponsable',
          label: 'Agente responsable',
          align: 'left',
          field: 'agenteResponsable',
          sortable: true
        },
        {
          name: 'editar',
          label: 'Editar',
          align: 'center',
          field: '',
          sortable: false
        },
        {
          name: 'eliminar',
          label: 'Eliminar',
          align: 'center',
          field: '',
          sortable: false
        }
      ],
      currentAccion: {}
    };
  },
  created () {
    this.visibleColumns = this.isOnlyAccess ? ['name', 'fase', 'plazo', 'agenteResponsable'] : ['name', 'fase', 'plazo', 'agenteResponsable', 'editar', 'eliminar'];
  },
  mounted () {
    this.$eventHub.$on('saveNewAccion', newAccion => {
      if (newAccion.position === null) this.acciones.push(newAccion);
      else {
        this.acciones[newAccion.position] = newAccion;
        Vue.set(this.acciones, newAccion.position, newAccion);
      }

      let dataIndicador = this.acciones;
      this.$emit('updateDataIndicadorAcciones', dataIndicador);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('saveNewAccion');
  },
  methods: {
    triggerDelete (row) {
      this.rowSelectedtoDelete = row;
      if (this.rowSelectedtoDelete.id !== null && this.rowSelectedtoDelete.id !== undefined) {
        this.$store.dispatch(types.ACTION_GET_IS_ACCION_ASOCIADA, {
          idCiudad: this.ciudadSelected.id,
          idAccion: this.rowSelectedtoDelete.id
        }).then((response) => {
          if (response.data === false) {
            this.showDialogDelete = true;
          } else {
          // mensaje de que no se puede borra la acción
            this.showPopUpNoBorraAccion = true;
          }
        });
      } else {
        this.showDialogDelete = true;
      }
    },
    deleteAccion () {
      // obtenemos indice
      const index = this.acciones.indexOf(this.rowSelectedtoDelete);
      // eliminamos el elemento
      this.acciones.splice(index, 1);
      this.showDialogDelete = false;

      let dataIndicador = this.acciones;
      this.$emit('updateDataIndicadorAcciones', dataIndicador);
    },
    triggerAdd () {
      this.currentAccion = {};
      this.showPopUpAddNewAccion = true;
    },
    triggerEdit (row) {
      const index = this.acciones.indexOf(row);
      row['position'] = index;
      this.currentAccion = row;
      this.showPopUpAddNewAccion = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.container-table {
  &::v-deep {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
      border: solid 3px #e9f4f6;
      border-radius: 12px;
    }
  }
  .divAddPlan {
    margin-bottom: 15px;
  }
  .rigth {
    float: right;
  }
}
.divInfo {
  margin: 15px 0px 1px 0px;
  font-family: DINPro;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #555;
}
</style>
